var _linearGradient, _path, _linearGradient2, _circle, _linearGradient3, _circle2, _linearGradient4, _path2, _linearGradient5, _circle3, _linearGradient6, _circle4, _linearGradient7, _path3, _linearGradient8, _circle5, _linearGradient9, _circle6, _linearGradient0, _path4, _linearGradient1, _circle7, _linearGradient10, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Services(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6a",
    x1: 8.146,
    x2: 26.654,
    y1: 24.146,
    y2: 42.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MjrnJJVR9GxuXmfoElIW6a)",
    d: "M29.63,29.968c-1.55,0.197-3.139-0.529-3.97-1.968c-0.83-1.438-0.665-3.177,0.28-4.421 c-1.468-1.394-3.256-2.45-5.249-3.039C20.088,21.984,18.663,23,17,23s-3.088-1.016-3.691-2.46c-1.993,0.59-3.781,1.645-5.249,3.039 C9.005,24.823,9.17,26.562,8.34,28c-0.83,1.438-2.419,2.165-3.97,1.968C4.137,30.942,4,31.954,4,33c0,1.046,0.137,2.058,0.37,3.032 c1.55-0.197,3.139,0.53,3.97,1.968c0.83,1.438,0.665,3.177-0.28,4.421c1.468,1.394,3.256,2.45,5.249,3.039 C13.912,44.016,15.337,43,17,43s3.088,1.016,3.691,2.46c1.993-0.59,3.781-1.645,5.249-3.039c-0.945-1.244-1.111-2.983-0.28-4.421 c0.83-1.438,2.419-2.165,3.97-1.968C29.863,35.058,30,34.046,30,33C30,31.954,29.863,30.942,29.63,29.968z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6b",
    x1: 21.877,
    x2: 12.058,
    y1: 37.877,
    y2: 28.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 33,
    r: 7,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6c",
    x1: 13.013,
    x2: 20.007,
    y1: 29.013,
    y2: 36.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 33,
    r: 4.261,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6c)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6d",
    x1: 8.146,
    x2: 26.654,
    y1: 24.146,
    y2: 42.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MjrnJJVR9GxuXmfoElIW6d)",
    d: "M29.63,29.968c-1.55,0.197-3.139-0.529-3.97-1.968c-0.83-1.438-0.665-3.177,0.28-4.421 c-1.468-1.394-3.256-2.45-5.249-3.039C20.088,21.984,18.663,23,17,23s-3.088-1.016-3.691-2.46c-1.993,0.59-3.781,1.645-5.249,3.039 C9.005,24.823,9.17,26.562,8.34,28c-0.83,1.438-2.419,2.165-3.97,1.968C4.137,30.942,4,31.954,4,33c0,1.046,0.137,2.058,0.37,3.032 c1.55-0.197,3.139,0.53,3.97,1.968c0.83,1.438,0.665,3.177-0.28,4.421c1.468,1.394,3.256,2.45,5.249,3.039 C13.912,44.016,15.337,43,17,43s3.088,1.016,3.691,2.46c1.993-0.59,3.781-1.645,5.249-3.039c-0.945-1.244-1.111-2.983-0.28-4.421 c0.83-1.438,2.419-2.165,3.97-1.968C29.863,35.058,30,34.046,30,33C30,31.954,29.863,30.942,29.63,29.968z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6e",
    x1: 21.877,
    x2: 12.058,
    y1: 37.877,
    y2: 28.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 33,
    r: 7,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6f",
    x1: 13.257,
    x2: 19.823,
    y1: 29.257,
    y2: 35.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 33,
    r: 4,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6g",
    x1: 26.036,
    x2: 41.715,
    y1: 8.018,
    y2: 23.698,
    gradientTransform: "rotate(-14.999 28.002 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MjrnJJVR9GxuXmfoElIW6g)",
    d: "M43.67,8.749c-1.226,0.501-2.685,0.255-3.68-0.74c-0.995-0.995-1.241-2.454-0.74-3.679 c-1.507-0.819-3.202-1.29-4.962-1.336c-0.177,1.314-1.12,2.458-2.481,2.823s-2.75-0.154-3.56-1.204 c-1.502,0.919-2.733,2.176-3.629,3.638c1.046,0.811,1.563,2.198,1.199,3.557c-0.364,1.359-1.505,2.302-2.817,2.481 c0.023,0.849,0.133,1.706,0.362,2.562c0.229,0.856,0.563,1.654,0.968,2.4c1.226-0.501,2.685-0.255,3.68,0.74 c0.995,0.995,1.241,2.454,0.74,3.679c1.507,0.819,3.202,1.29,4.962,1.336c0.177-1.314,1.12-2.458,2.481-2.823 c1.361-0.365,2.75,0.154,3.56,1.204c1.502-0.919,2.733-2.176,3.629-3.638c-1.046-0.811-1.563-2.198-1.199-3.557 c0.364-1.359,1.505-2.302,2.817-2.481c-0.023-0.849-0.133-1.706-0.362-2.562C44.409,10.294,44.075,9.496,43.67,8.749z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6h",
    x1: 37.668,
    x2: 29.35,
    y1: 19.65,
    y2: 11.332,
    gradientTransform: "rotate(-14.999 28.002 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 5.93,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6h)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6i",
    x1: 30.159,
    x2: 36.084,
    y1: 12.141,
    y2: 18.066,
    gradientTransform: "rotate(-14.999 28.002 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 3.61,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6i)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6j",
    x1: 26.036,
    x2: 41.715,
    y1: 8.018,
    y2: 23.698,
    gradientTransform: "rotate(-14.999 28.002 13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#MjrnJJVR9GxuXmfoElIW6j)",
    d: "M43.67,8.749c-1.226,0.501-2.685,0.255-3.68-0.74c-0.995-0.995-1.241-2.454-0.74-3.679 c-1.507-0.819-3.202-1.29-4.962-1.336c-0.177,1.314-1.12,2.458-2.481,2.823s-2.75-0.154-3.56-1.204 c-1.502,0.919-2.733,2.176-3.629,3.638c1.046,0.811,1.563,2.198,1.199,3.557c-0.364,1.359-1.505,2.302-2.817,2.481 c0.023,0.849,0.133,1.706,0.362,2.562c0.229,0.856,0.563,1.654,0.968,2.4c1.226-0.501,2.685-0.255,3.68,0.74 c0.995,0.995,1.241,2.454,0.74,3.679c1.507,0.819,3.202,1.29,4.962,1.336c0.177-1.314,1.12-2.458,2.481-2.823 c1.361-0.365,2.75,0.154,3.56,1.204c1.502-0.919,2.733-2.176,3.629-3.638c-1.046-0.811-1.563-2.198-1.199-3.557 c0.364-1.359,1.505-2.302,2.817-2.481c-0.023-0.849-0.133-1.706-0.362-2.562C44.409,10.294,44.075,9.496,43.67,8.749z"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6k",
    x1: 37.668,
    x2: 29.35,
    y1: 19.65,
    y2: 11.332,
    gradientTransform: "translate(.463 -1.519)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 5.93,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6k)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "MjrnJJVR9GxuXmfoElIW6l",
    x1: 30.366,
    x2: 35.928,
    y1: 12.348,
    y2: 17.91,
    gradientTransform: "translate(.463 -1.519)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#0e5fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#135796"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 14,
    r: 3.389,
    fill: "url(#MjrnJJVR9GxuXmfoElIW6l)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Services);
export default __webpack_public_path__ + "static/media/icons8-services.e88a02fcbd052cf2b79571e877d8a142.svg";
export { ForwardRef as ReactComponent };